import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { Match2RewardItem } from '../components/Match2RewardItem';

export class Match2TournamentPrize extends View {
  private rewards?: Match2Reward[];
  private amount?: number;
  private readonly rewardsContainer: FlexBoxView;

  constructor(opts: ViewOpts) {
    super({
      width: 80,
      height: 80,
      ...opts,
    });

    this.rewardsContainer = new FlexBoxView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      flex: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignContent: 'center',
      },
    });
  }

  public setup(
    rewards: Match2Reward[],
    opts?: { itemSize: number; labelSize: number },
  ) {
    this.rewardsContainer.removeAllSubviews();

    this.rewards = rewards;

    this.rewards.forEach((reward) => {
      const prizeView = new Match2RewardItem({
        superview: this.rewardsContainer,
        size: opts?.itemSize ?? 60,
        labelSize: opts?.labelSize ?? 20,
        labelOffsetY: 5,
      });
      prizeView.setReward(reward);
    });
  }
}
